import PropTypes from 'prop-types'

import { emailValidator, presenceValidator } from '@utils/validators'

export const values = {
  email: '',
}

export const validations = {
  email: [
    { validator: presenceValidator, message: 'Email is missing' },
    { validator: emailValidator, message: 'Email is not valid' },
  ],
}

export const LEAD_PROP_TYPES = PropTypes.shape({
  email: PropTypes.string,
})
